import SEO from "../components/SEO";
import Banner from "../components/Banner";
import {
  CreditCardIcon, EnvelopeOpenIcon, ChartBarIcon, CheckIcon,
  DevicePhoneMobileIcon, ArrowRightIcon, SparklesIcon,
} from "@heroicons/react/24/outline";
import imag1    from "../assets/cat.png";
import image2   from "../assets/osbrilhantes.png";
import image3   from "../assets/martires.png";
import logoImetro   from "../assets/escolas/imetro.png";
import logoIsptec   from "../assets/escolas/isptec.png";
import logoGirasol  from "../assets/escolas/girasol.png";
import logoUnibelas from "../assets/escolas/unibelas.png";
import logoPitruca  from "../assets/escolas/pitruca.png";

/* ── Data ── */
const services = [
  {
    Icon: CreditCardIcon, num: "01",
    title: "Pagamento de Propínas",
    desc: "Receba pagamentos dos seus estudantes em tempo real, sem papelada e sem filas.",
    grad: "from-blue-500/8 to-blue-600/3", ico: "bg-blue-100 text-blue-600",
    link: "/payment",
  },
  {
    Icon: EnvelopeOpenIcon, num: "02",
    title: "Envio de Convocatórias",
    desc: "Envie convocatórias a todos os encarregados de forma rápida, segura e sem custos.",
    grad: "from-violet-500/8 to-violet-600/3", ico: "bg-violet-100 text-violet-600",
    link: "/payment",
  },
  {
    Icon: ChartBarIcon, num: "03",
    title: "Gestão Escolar Completa",
    desc: "Gerencie propinas, presenças e relatórios da sua instituição num só lugar.",
    grad: "from-emerald-500/8 to-emerald-600/3", ico: "bg-emerald-100 text-emerald-600",
    link: "/payment",
  },
];

const howSteps = [
  {
    n: "1", Icon: SparklesIcon,
    title: "Registe a sua instituição",
    desc: "Crie a conta em menos de 5 minutos. Sem papelada, sem burocracia.",
    color: "text-blue bg-blue/10",
  },
  {
    n: "2", Icon: DevicePhoneMobileIcon,
    title: "Configure os seus serviços",
    desc: "Defina propinas, turmas, encarregados e canais de notificação.",
    color: "text-violet-600 bg-violet-100",
  },
  {
    n: "3", Icon: CreditCardIcon,
    title: "Receba em tempo real",
    desc: "Os encarregados pagam pelo telemóvel ou PC e você recebe na hora.",
    color: "text-emerald-600 bg-emerald-100",
  },
];

const plans = [
  {
    name: "Gratuito", badge: "Teste", price: "0 Kz", period: "/mês",
    features: ["20 GB de espaço", "Até 500 estudantes", "Convocatórias", "Gestão de pagamentos", "Acesso Web (PC)"],
    cta: "Começar Grátis", highlighted: false,
  },
  {
    name: "Ilimitado", badge: "Mais popular", price: "100.000 Kz", period: "/mês",
    features: ["3 TB de espaço", "Estudantes ilimitados", "E-mail para encarregados", "Gestão escolar completa", "Chat integrado", "Web, Mobile e TV"],
    cta: "Aderir Agora", highlighted: true,
  },
  {
    name: "Mími", badge: "", price: "35.000 Kz", period: "/mês",
    features: ["1 TB de espaço", "Até 200.000 estudantes", "E-mail para encarregados", "Gestão de pagamentos", "Web e Mobile"],
    cta: "Aderir Agora", highlighted: false,
  },
];

const schools = [
  { img: image2, name: "Colégio Os Brilhantes",        desc: "Formando os melhores quadros para ingresso à universidade." },
  { img: imag1,  name: "Colégio Angolano de Talatona", desc: "Dedicados à formação de excelência há mais de 4 anos." },
  { img: image3, name: "Colégio Mártires do Uganda",   desc: "Mais de 18 anos formando os melhores quadros do país." },
];

const partnerLogos = [logoImetro, logoIsptec, logoGirasol, logoUnibelas, logoPitruca];

/* ══════════════════════════════════════════════════
   PAGE
══════════════════════════════════════════════════ */
export default function Home() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "PIA — Plataforma de Pagamentos Escolares em Angola",
    "url": "https://pia-payment.vercel.app/",
    "description": "Pague propinas, matrículas e serviços escolares online em Angola, sem filas e sem deslocações.",
    "breadcrumb": { "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Início", "item": "https://pia-payment.vercel.app/" }] },
  };

  return (
    <>
      <SEO
        title="Plataforma de Pagamentos Escolares em Angola"
        description="PIA é a plataforma líder em Angola para pagamento de propinas, matrículas e gestão escolar online. Pague sem filas, em segundos, de qualquer dispositivo. Mais de 500 instituições activas."
        path="/"
        schema={schema}
      />
      <Banner />

      {/* ── LOGOS STRIP ── */}
      <section className="py-10 bg-white border-b border-border">
        <div className="max-w-5xl mx-auto px-6">
          <p className="text-center text-muted/60 text-[11px] font-semibold uppercase tracking-widest mb-8">
            Confiado por instituições em Angola
          </p>
          <div className="flex items-center justify-center gap-8 flex-wrap">
            {partnerLogos.map((src, i) => (
              <div key={i}
                className="flex items-center justify-center opacity-40 grayscale hover:opacity-80 hover:grayscale-0 transition-all duration-300"
                style={{ width: 80, height: 56 }}>
                <img src={src} alt="parceiro"
                  className="max-w-full max-h-full object-contain"
                  style={{ maxWidth: 80, maxHeight: 52 }} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SERVIÇOS ── */}
      <section id="services" className="py-24 bg-off-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-blue-light font-semibold text-xs uppercase tracking-widest">O que oferecemos</span>
            <h2 className="text-3xl font-extrabold text-dark mt-2">Serviços Disponíveis</h2>
            <p className="text-muted mt-3 text-sm max-w-lg mx-auto">
              As ferramentas certas para modernizar a gestão financeira da sua instituição
            </p>
          </div>

          <div className="grid grid-cols-3 gap-6 max-md:grid-cols-1">
            {services.map(({ Icon, num, title, desc, grad, ico, link }) => (
              <div key={title}
                className={`bg-linear-to-br ${grad} rounded-2xl p-8 border border-border hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group flex flex-col`}>
                <div className="flex items-start justify-between mb-5">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${ico} group-hover:scale-110 transition-transform`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <span className="text-3xl font-black text-dark/6 select-none">{num}</span>
                </div>
                <h3 className="text-dark font-bold text-base mb-2">{title}</h3>
                <p className="text-muted text-sm leading-relaxed flex-1">{desc}</p>
                <a href={link}
                  className="inline-flex items-center gap-1 mt-6 text-blue text-xs font-semibold hover:gap-2 transition-all">
                  Saber mais <ArrowRightIcon className="w-3.5 h-3.5" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── COMO FUNCIONA ── */}
      <section className="py-24 bg-sky">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-blue-light font-semibold text-xs uppercase tracking-widest">Simples e rápido</span>
            <h2 className="text-3xl font-extrabold text-dark mt-2">Como Funciona</h2>
            <p className="text-muted mt-3 text-sm">Comece a receber propinas em 3 passos simples</p>
          </div>

          <div className="relative grid grid-cols-3 gap-8 max-md:grid-cols-1">
            {/* Connector line between icons */}
            <div className="absolute top-10 left-[calc(16.67%+40px)] right-[calc(16.67%+40px)] h-px bg-linear-to-r from-blue-light/20 via-blue-light/50 to-blue-light/20 max-md:hidden" />

            {howSteps.map(({ n, Icon, title, desc, color }) => (
              <div key={n} className="flex flex-col items-center text-center">
                {/* Icon + number badge */}
                <div className="relative mb-6">
                  <div className={`w-20 h-20 rounded-2xl flex items-center justify-center shadow-sm ${color}`}>
                    <Icon className="w-8 h-8" />
                  </div>
                  <span
                    className="absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center text-xs font-black text-white shadow-md"
                    style={{ background: "linear-gradient(135deg, #2babe3, #016fb9)" }}
                  >
                    {n}
                  </span>
                </div>
                <h3 className="text-dark font-bold text-base mb-2">{title}</h3>
                <p className="text-muted text-sm leading-relaxed max-w-xs">{desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-14">
            <a href="/register"
              className="inline-flex items-center gap-2 text-white font-semibold px-8 py-4 rounded-full text-sm shadow-lg shadow-blue/20 transition-all hover:opacity-90 hover:scale-105"
              style={{ background: "linear-gradient(90deg, #2babe3, #016fb9)" }}>
              Começar gratuitamente
              <ArrowRightIcon className="w-4 h-4" />
            </a>
          </div>
        </div>
      </section>

      {/* ── PLANOS ── */}
      <section id="about" className="py-24 bg-off-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-blue-light font-semibold text-xs uppercase tracking-widest">Preços Transparentes</span>
            <h2 className="text-3xl font-extrabold text-dark mt-2">Escolha o Seu Plano</h2>
            <p className="text-muted mt-3 text-sm">Sem surpresas. Cancele quando quiser.</p>
          </div>

          <div className="grid grid-cols-3 gap-6 items-center max-md:grid-cols-1">
            {plans.map(({ name, badge, price, period, features, cta, highlighted }) => (
              <div key={name}
                className={`relative rounded-2xl p-8 border transition-all duration-300 ${
                  highlighted
                    ? "text-white border-transparent shadow-2xl scale-105 max-md:scale-100"
                    : "bg-white text-dark border-border hover:shadow-xl hover:-translate-y-1"
                }`}
                style={highlighted ? { background: "linear-gradient(145deg, #002849, #0569a3)" } : {}}
              >
                {badge && (
                  <span className={`absolute -top-3 left-1/2 -translate-x-1/2 text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap ${
                    highlighted ? "text-white" : "bg-sky text-blue border border-border"
                  }`}
                    style={highlighted ? { background: "linear-gradient(90deg,#2babe3,#016fb9)" } : {}}
                  >
                    {badge}
                  </span>
                )}

                <h3 className={`font-bold text-lg mb-1 ${highlighted ? "text-white" : "text-dark"}`}>{name}</h3>
                <div className="flex items-baseline gap-1 mb-1">
                  <span className={`text-2xl font-extrabold ${highlighted ? "text-blue-light" : "text-blue"}`}>{price}</span>
                  <span className={`text-xs ${highlighted ? "text-white/50" : "text-muted"}`}>{period}</span>
                </div>

                <div className={`border-t my-5 ${highlighted ? "border-white/15" : "border-border"}`} />

                <ul className="space-y-3 mb-8">
                  {features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm">
                      <CheckIcon className={`w-4 h-4 shrink-0 mt-0.5 ${highlighted ? "text-blue-light" : "text-emerald-500"}`} />
                      <span className={highlighted ? "text-white/75" : "text-muted"}>{f}</span>
                    </li>
                  ))}
                </ul>

                <a href="/register"
                  className={`block w-full text-center py-3 rounded-full font-semibold text-sm transition-all hover:scale-105 ${
                    highlighted
                      ? "bg-white text-brand hover:bg-off-white"
                      : "border-2 border-blue text-blue hover:bg-blue hover:text-white"
                  }`}>
                  {cta}
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── MID CTA BANNER ── */}
      <section className="relative overflow-hidden py-20">
        <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, #001627 0%, #002849 60%, #0569a3 100%)" }} />
        <div className="absolute inset-0 pointer-events-none" style={{
          backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.04) 1px, transparent 1px)",
          backgroundSize: "24px 24px",
        }} />
        <div className="absolute -right-24 top-1/2 -translate-y-1/2 w-96 h-96 rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(43,171,227,0.2) 0%, transparent 65%)" }} />

        <div className="relative max-w-4xl mx-auto px-6 text-center">
          <span className="inline-flex items-center gap-2 bg-white/10 border border-white/15 text-blue-light text-xs font-semibold px-4 py-1.5 rounded-full mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-blue-light" />
            Sem cartão de crédito necessário
          </span>
          <h2 className="text-4xl font-extrabold text-white mb-4 max-md:text-2xl">
            Pronto para modernizar{" "}
            <span className="text-transparent bg-clip-text"
              style={{ backgroundImage: "linear-gradient(90deg, #2babe3, #7dd3fc)" }}>
              a sua escola?
            </span>
          </h2>
          <p className="text-white/55 text-base mb-10 max-w-xl mx-auto">
            Junte-se a mais de 500 instituições que já utilizam o PIA para gerir pagamentos e comunicar com encarregados.
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <a href="/register"
              className="inline-flex items-center gap-2 text-white font-bold px-8 py-4 rounded-full text-sm shadow-lg shadow-blue/30 transition-all hover:opacity-90 hover:scale-105"
              style={{ background: "linear-gradient(90deg, #2babe3, #016fb9)" }}>
              Criar conta gratuita
              <ArrowRightIcon className="w-4 h-4" />
            </a>
            <a href="#contact"
              className="inline-flex items-center gap-2 border border-white/20 hover:bg-white/10 text-white/80 hover:text-white font-medium px-8 py-4 rounded-full text-sm transition-all">
              Falar com a equipa
            </a>
          </div>
        </div>
      </section>

      {/* ── PARCEIROS ── */}
      <section className="py-24 bg-off-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-blue-light font-semibold text-xs uppercase tracking-widest">Parceiros</span>
            <h2 className="text-3xl font-extrabold text-dark mt-2">Instituições que Confiam em Nós</h2>
            <p className="text-muted mt-3 text-sm">Escolas e universidades que já modernizaram a sua gestão</p>
          </div>

          <div className="grid grid-cols-3 gap-6 max-md:grid-cols-1">
            {schools.map(({ img, name, desc }) => (
              <div key={name}
                className="bg-white rounded-2xl overflow-hidden border border-border hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300 group">
                <div className="h-52 overflow-hidden relative">
                  <img src={img} alt={name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-linear-to-t from-dark/30 to-transparent" />
                </div>
                <div className="p-6">
                  <h3 className="font-bold text-dark text-sm mb-2">{name}</h3>
                  <p className="text-muted text-xs leading-relaxed">{desc}</p>
                  <a href="#" className="inline-flex items-center gap-1 mt-4 text-blue text-xs font-semibold hover:gap-2 transition-all">
                    Saber mais <ArrowRightIcon className="w-3 h-3" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CONTACTO ── */}
      <section id="contact" className="relative py-24 overflow-hidden"
        style={{ background: "linear-gradient(135deg, #001627 0%, #002849 50%, #0569a3 100%)" }}>
        <div className="absolute inset-0 pointer-events-none" style={{
          backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.05) 1px, transparent 1px)",
          backgroundSize: "28px 28px",
        }} />
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(43,171,227,0.15) 0%, transparent 70%)" }} />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(5,105,163,0.2) 0%, transparent 65%)" }} />

        <div className="relative max-w-4xl mx-auto px-6">
          <div className="text-center mb-14">
            <span className="text-blue-light font-semibold text-xs uppercase tracking-widest">Fale Connosco</span>
            <h2 className="text-3xl font-extrabold text-white mt-2">Contacte-nos</h2>
            <p className="text-white/50 text-sm mt-3">Estamos prontos para ajudar a sua instituição</p>
          </div>

          <div className="flex gap-14 max-md:flex-col">
            {/* Form */}
            <form className="flex-2 flex flex-col gap-4">
              {[
                { label: "Nome Completo", type: "text",  placeholder: "Ex: João Silva" },
                { label: "Email",         type: "email", placeholder: "joao@exemplo.com" },
                { label: "Telefone",      type: "text",  placeholder: "+244 ..." },
              ].map(({ label, type, placeholder }) => (
                <div key={label}>
                  <label className="block text-white/60 text-xs mb-1.5 font-medium">{label}</label>
                  <input type={type} placeholder={placeholder}
                    className="w-full bg-white/8 border border-white/15 rounded-xl px-4 py-3 text-white text-sm placeholder:text-white/30 outline-none focus:border-blue-light transition-colors" />
                </div>
              ))}
              <div>
                <label className="block text-white/60 text-xs mb-1.5 font-medium">Mensagem</label>
                <textarea rows={4} placeholder="Como podemos ajudar?"
                  className="w-full bg-white/8 border border-white/15 rounded-xl px-4 py-3 text-white text-sm placeholder:text-white/30 outline-none focus:border-blue-light transition-colors resize-none" />
              </div>
              <button className="text-white font-bold py-4 rounded-2xl mt-1 text-sm transition-all hover:opacity-90 hover:scale-[1.01] flex items-center justify-center gap-2"
                style={{ background: "linear-gradient(90deg, #2babe3, #016fb9)" }}>
                Enviar Mensagem
                <ArrowRightIcon className="w-4 h-4" />
              </button>
            </form>

            {/* Info */}
            <div className="flex-1 flex flex-col justify-center gap-6">
              {[
                { label: "Endereço", lines: ["Benfica, Luanda, Angola"] },
                { label: "Telefone", lines: ["(+244) 944-969-865", "(+244) 990-969-865"] },
                { label: "Email",    lines: ["pia.server@pco.co.ao"] },
              ].map(({ label, lines }, i) => (
                <div key={label}>
                  {i > 0 && <div className="border-t border-white/10 mb-5" />}
                  <p className="font-bold text-white/50 text-xs uppercase tracking-widest mb-2">{label}</p>
                  {lines.map((l) => (
                    <p key={l} className="text-white text-sm font-medium">{l}</p>
                  ))}
                </div>
              ))}

              {/* Social proof box */}
              <div className="mt-4 bg-white/8 border border-white/12 rounded-2xl p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
                  <span className="text-emerald-400 text-xs font-semibold">Suporte activo</span>
                </div>
                <p className="text-white/60 text-xs leading-relaxed">
                  A nossa equipa responde em menos de 2 horas nos dias úteis.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
